"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const compact_1 = __importDefault(require("lodash/compact"));
const useGroupObjectives_1 = require("hooks/api/useGroupObjectives");
const useObjectives_1 = require("hooks/api/useObjectives");
const useIntersectionObserver_1 = __importDefault(require("hooks/useIntersectionObserver"));
const useUrl_1 = require("hooks/useUrl");
const HelperUtils_1 = require("utils/HelperUtils");
const ObjectivesHelper_1 = require("utils/ObjectivesHelper");
const VisibilityHelper_1 = require("utils/VisibilityHelper");
const HeaderPage_1 = __importDefault(require("components/admin/HeaderPage"));
const AdvancedFilterObjectives_1 = __importDefault(require("components/advance-filter/AdvancedFilterObjectives"));
const Accordion_1 = __importDefault(require("components/design-system/accordion/Accordion"));
const Objectives_1 = __importDefault(require("components/objectives/Objectives"));
const ObjectiveSkeleton_1 = __importDefault(require("components/shared/ObjectiveSkeleton"));
const SidebarMyGoals_1 = __importDefault(require("components/sidebar/SidebarMyGoals"));
const listTab = ['company', 'directorate', 'department', 'division'];
const CompanyGoals = ({ route: { title }, history }) => {
    const { match } = (0, useUrl_1.useUrl)();
    const params = (0, react_router_dom_1.useParams)();
    const { isGoalCreator, isGrouping, isShowTab } = (0, VisibilityHelper_1.usePermission)();
    const switchOptions = (0, compact_1.default)(listTab.map((tab) => {
        if (tab == 'company' || isShowTab(tab)) {
            return {
                id: tab,
                name: (0, HelperUtils_1.capitalize)((0, HelperUtils_1.getObjectiveLocale)(tab)),
                filter: { [VisibilityHelper_1.listGoalType[tab]]: true },
                onClick: () => history.replace(`/goals/level/${tab}`)
            };
        }
    })) || [];
    const defaultTab = switchOptions?.find((tab) => tab?.id === params?.tab)?.id ||
        switchOptions[0]?.id;
    const [activeTab, changeTab] = (0, react_1.useState)(defaultTab);
    const optionActive = switchOptions.find((option) => option?.id === activeTab) || {};
    const goalType = VisibilityHelper_1.listGoalType[optionActive?.id];
    const extraFilter = optionActive?.filter || {};
    const objectivesProps = {
        cardModel: 'goal-list',
        extraFilter: extraFilter,
        page: `companyGoals+${activeTab}`,
        emptyStateAction: () => history.replace({
            pathname: '/create-objective/goal',
            state: {
                prevPath: location.pathname,
                [goalType]: true
            }
        })
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(HeaderPage_1.default, { titlePage: title, primaryAction: isGoalCreator(optionActive.id) && {
                title: (0, HelperUtils_1.getObjectiveLocale)(`Create New ${(0, HelperUtils_1.capitalize)(optionActive.id)} Goals`),
                icon: 'icon-add',
                onClick: () => {
                    history.replace({
                        pathname: '/create-objective/goal',
                        state: {
                            prevPath: location.pathname,
                            [goalType]: true
                        }
                    });
                }
            }, tabs: {
                tabsList: switchOptions,
                url: '/goals/level/company',
                // @ts-ignore
                onChange: changeTab
            } }),
        react_1.default.createElement("div", { className: "grid gap-[24px] mb-[64px] mt-[24px] company-goals" },
            react_1.default.createElement(AdvancedFilterObjectives_1.default, { filterOptions: ['search', 'dateFilter', 'menuFilter'], defaultDateFilterOptions: ['annual', 'all_time', 'last_year'], page: `companyGoals+${activeTab}`, filterId: "companyGoalsFilter", exceptFilterMenu: ['myInvolvement'] }, isGrouping(optionActive?.id) ? (react_1.default.createElement(ObjectivesGroup, { optionActive: optionActive, ...objectivesProps })) : (react_1.default.createElement(Objectives_1.default, { ...objectivesProps })))),
        react_1.default.createElement(react_1.default.Suspense, { fallback: react_1.default.createElement("div", null) }, match && react_1.default.createElement(SidebarMyGoals_1.default, null))));
};
const ObjectivesGroup = ({ optionActive, cardModel, extraFilter, page, emptyStateAction, ...rest }) => {
    const { filter } = rest;
    const [groupData, setGroupData] = (0, react_1.useState)({});
    const { isFetching, hasNextPage, fetchNextPage } = (0, useGroupObjectives_1.useGetGroupObjectives)('myGoals', optionActive?.id, {
        suspense: false,
        onSuccess: (data) => {
            const newData = {
                key: '',
                metadata: null,
                values: []
            };
            data?.pages?.map((page) => {
                const data = page?.data;
                newData.key = data?.key;
                newData.metadata = data?.metadata;
                newData.values.push(...(data?.values || []));
            });
            newData && setGroupData(newData);
        }
    });
    const intersectTarget = (0, react_1.createRef)();
    (0, useIntersectionObserver_1.default)({
        target: intersectTarget,
        onIntersect: (entry) => entry.isIntersecting &&
            hasNextPage &&
            !isFetching &&
            groupData?.metadata?.pagination?.nextOffset &&
            fetchNextPage(),
        threshold: 0.5
    });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        optionActive?.id === groupData?.key &&
            groupData.values?.map((data, idx) => {
                const groupFilter = {
                    ...extraFilter,
                    ...(0, ObjectivesHelper_1.restructureFilter)({
                        ...filter,
                        owner: {
                            [groupData.key]: data?.name
                        }
                    })
                };
                return (react_1.default.createElement("div", { "data-cy": "group-objectives", key: `${groupData?.key}-${data?.name}-${idx}`, ref: idx == groupData?.values?.length - 1 &&
                        groupData?.values?.length > 9
                        ? intersectTarget
                        : undefined },
                    react_1.default.createElement(Accordion_1.default, { useBorder: true, key: `${groupData?.key}-${data?.name}-${idx}` },
                        react_1.default.createElement(AccordionHeader, { data: data, groupFilter: groupFilter }),
                        react_1.default.createElement(Accordion_1.default.Content, { useSeparator: true, customClass: "overflow-y-auto max-h-[568px]", customSpaceClass: "px-[24px] py-[16px]" },
                            react_1.default.createElement(Objectives_1.default, { extraFilter: groupFilter, page: page, cardModel: cardModel, emptyStateAction: emptyStateAction, isRefetch: isFetching, useObjectiveGroup: true })))));
            }),
        (optionActive?.id !== groupData?.key || isFetching) && (react_1.default.createElement(ObjectiveSkeleton_1.default, null))));
};
const AccordionHeader = ({ data, groupFilter }) => {
    const filterCount = {
        ...groupFilter,
        ignoreInvolvements: true
    };
    filterCount?.limit && delete filterCount?.limit;
    const { data: totalObjectivesData } = (0, useObjectives_1.useGetTotalObjectives)(filterCount, {
        staleTime: 5 * 60 * 1000
    });
    const totalObjectives = totalObjectivesData?.data?.totalObjectives || 0;
    return (react_1.default.createElement(Accordion_1.default.Header, { customSpaceClass: "px-[24px] py-[16px]" },
        react_1.default.createElement("div", { className: "w-full h-[36px] flex items-center justify-between border-solid border-y-0 border-r-[1px] border-l-0 border-n-400 border" },
            react_1.default.createElement("p", { className: "typography-h500" }, data?.name),
            react_1.default.createElement("p", { className: "typography-h100 text-n-800 px-[16px]" }, (0, HelperUtils_1.getObjectiveLocale)(`${totalObjectives} Goal${totalObjectives > 1 ? 's' : ''}`)))));
};
exports.default = CompanyGoals;
